import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgAppleLogoLarge = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={100}
      height={100}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__apple-logo-large_svg__a)">
        <path
          d="M53.556 20.503c4.693-6.186 11.217-6.216 11.217-6.216s.97 5.816-3.692 11.418c-4.978 5.982-10.636 5.003-10.636 5.003s-1.063-4.705 3.11-10.205ZM51.041 34.78c2.414 0 6.895-3.318 12.727-3.318 10.04 0 13.99 7.143 13.99 7.143s-7.725 3.95-7.725 13.533c0 10.81 9.622 14.536 9.622 14.536S72.93 85.608 63.844 85.608c-4.173 0-7.418-2.812-11.815-2.812-4.48 0-8.927 2.917-11.823 2.917-8.297 0-18.778-17.96-18.778-32.397 0-14.203 8.872-21.654 17.193-21.654 5.41 0 9.608 3.12 12.42 3.12Z"
          fill="#999"
        />
      </g>
      <defs>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__apple-logo-large_svg__a">
          <path
            fill="#fff"
            transform="translate(21.428 14.286)"
            d="M0 0h58.229v71.429H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgAppleLogoLarge;
